var _circle, _circle2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 31,
    fill: "url(#paint0_linear_1095_20493)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 35.5,
    stroke: "url(#paint1_linear_1095_20493)",
    strokeOpacity: 0.1,
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 31.8211C56.8194 32.6038 56.8255 33.9103 56.0135 34.7006L38.6278 51.6214C37.8428 52.3854 36.5893 52.3758 35.8161 51.5999L26.9642 42.7168C26.1643 41.9141 26.1904 40.6079 27.0217 39.8378L28.6059 38.3703C29.3954 37.639 30.6221 37.6635 31.3817 38.4258L36.5824 43.6448C36.969 44.0327 37.5957 44.0375 37.9882 43.6556L51.6645 30.3449C52.4358 29.5943 53.6627 29.5886 54.4409 30.3319L56 31.8211Z",
    fill: "#16191E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1095_20493",
    x1: 40.5,
    y1: 70.8454,
    x2: 40.5,
    y2: 9.05417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1EE0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3EE13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1095_20493",
    x1: 71.4457,
    y1: 40,
    x2: 9.55426,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1EE0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3EE13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.5233d95a89d188f33d7b6aebe0e5a84a.svg";
export { ForwardRef as ReactComponent };